import React, { memo, useEffect, useState } from 'react'
import { CustomLink } from './styles'
import UseTermsModal from './components/UseTermsModal'
import RegulationModal from './components/RegulationModal'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { GetThemeColorFromStorage } from '../../../../redux/api/themeColor'
import { Grid } from '@material-ui/core'
import { Box } from '@mui/material'
import RegisterCheckbox from '../RegisterCheckbox'

function SelectAll({ errors, control, watch, setValue, generalRules, theme }) {
    const [themeColor, setThemeColor] = useState(
        theme || GetThemeColorFromStorage(),
    )
    const { t } = useTranslation()

    const [open, setOpen] = useState({
        useTerms: false,
        regulation: false,
    })

    useEffect(() => {
        setThemeColor(theme || GetThemeColorFromStorage())
    }, [])

    const termRef = useRef(false)
    const regulationRef = useRef(false)

    const handleClick = (name) => {
        if (name === 'useTerms') {
            if (termRef.current) {
                termRef.current.innerHTML = generalRules.useTerms
            }
        }

        if (name === 'regulation') {
            if (regulationRef.current) {
                regulationRef.current.innerHTML = generalRules.regulation
            }
        }
        setOpen({ ...open, [name]: !open[name] })
    }

    const optionsArray = [
        {
            name: 'selectAll',
            label: <p>{t('Select_All')}</p>,
        },
        {
            name: 'useTerms',
            label: (
                <p style={{ display: 'flex' }}>
                    {t('FIELD_REGISTER_ACCEPT')}
                    <CustomLink
                        themeColor={themeColor}
                        to="#"
                        onClick={() => handleClick('useTerms')}
                    >
                        {t('TITLE_PLATFORM_RULES_USE_TERMS')}
                    </CustomLink>
                    .
                </p>
            ),
        },

        {
            name: 'useRegulation',
            label: (
                <p style={{ display: 'flex' }}>
                    {t('FIELD_REGULATION_ACCEPT')}{' '}
                    <CustomLink
                        themeColor={themeColor}
                        to="#"
                        onClick={() => handleClick('regulation')}
                    >
                        {t('FIELD_REGULATION_PROGRAM')}
                    </CustomLink>
                    .
                </p>
            ),
        },
        {
            name: 'usePrivacyPolicy',
            label: (
                <p style={{ display: 'flex' }}>
                    {t('ACCEPTED')}{' '}
                    <CustomLink
                        themeColor={themeColor}
                        to="/privacypolicies"
                        target="_blank"
                    >
                        {t('TITLE_PLATFORM_RULES_PRIVACY_POLICY')}
                    </CustomLink>
                    .
                </p>
            ),
        },
        {
            name: 'newsletter',
            label: <p>{t('FIELD_REGISTER_NOTIFICATION')}.</p>,
        },
    ]

    const handleClose = () => {
        setOpen({
            useTerm: false,
            regulation: false,
        })
    }

    return (
        <Grid container item xs={12} spacing={2} alignItems="flex-start">
            <Grid item xs={12} sx={{ marginBottom: '20px' }}>
                <Box
                    sx={{
                        padding: '15px',
                        background: '#F4F4F4 0% 0% no-repeat padding-box',
                        borderRadius: '8px',
                        p: {
                            color: '#333333',
                            font: 'normal normal normal 12px/21px Roboto',
                        },
                    }}
                >
                    <RegisterCheckbox
                        xs={6}
                        themeColor={themeColor}
                        options={optionsArray}
                        {...{ errors, control, setValue, watch }}
                    />
                </Box>
            </Grid>
            <UseTermsModal {...{ open, ref: termRef, handleClose }} />
            <RegulationModal {...{ open, ref: regulationRef, handleClose }} />
        </Grid>
    )
}

export default memo(SelectAll)
